<template>
    <div>
        <div id="map"></div>
    </div>
</template>

<script>
    import {EventBus} from "../event-bus";

    export default {
        name: "MapComponent",
        props: {
            lat: String,
            long: String
        },
        methods: {
            getNormalizedCoord(coord, zoom) {
                const y = coord.y;
                let x = coord.x; // tile range in one direction range is dependent on zoom level
                // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc

                const tileRange = 1 << zoom; // don't repeat across y-axis (vertically)

                if (y < 0 || y >= tileRange) {
                    return null;
                } // repeat across x-axis

                if (x < 0 || x >= tileRange) {
                    x = ((x % tileRange) + tileRange) % tileRange;
                }

                return {
                    x: x,
                    y: y,
                };
            },
            initMap() {
                let normFunc = this.getNormalizedCoord;
                const map = new google.maps.Map(document.getElementById("map"), {
                    center: {
                        lat: 0,
                        lng: 0,
                    },
                    zoom: 1,
                    streetViewControl: false,
                    mapTypeControlOptions: {
                        mapTypeIds: ["ballasthoeve"],
                    },
                });
                const MapType = new google.maps.ImageMapType({
                    getTileUrl: function (coord, zoom) {
                        const normalizedCoord = normFunc(coord, zoom);

                        if (!normalizedCoord) {
                            return "";
                        }

                        const bound = Math.pow(2, zoom);
                        return (
                            "../frontend/img/maps/crops/zoom_" +
                            zoom +
                            "/x" +
                            normalizedCoord.x +
                            "/y" +
                            (bound - normalizedCoord.y - 1) +
                            ".jpeg?v=2023"
                        );
                    },
                    tileSize: new google.maps.Size(256, 256),
                    defaultZoom: 2,
                    maxZoom: 4,
                    minZoom: 2,
                    radius: 1738000,
                    name: "Ballasthoeve",
                });
                map.mapTypes.set("ballasthoeve", MapType);
                map.setMapTypeId("ballasthoeve");

                let allMarkers = [];

                // If lat and long props are both provided a marker should be created
                if (this.lat !== undefined && this.long !== undefined) {
                    const myLatLng = { lat: parseFloat(this.lat), lng: parseFloat(this.long) };
                    let marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map
                    });
                    allMarkers.push(marker);
                    marker.setMap(map);
                }

                google.maps.event.addListener(map, 'click', (event) => {
                    // If a marker has already been placed remove the first one
                    if (allMarkers.length > 0) {
                        allMarkers[0].setMap(null);
                        allMarkers = [];
                    }

                    let marker = new google.maps.Marker({
                        position: event.latLng,
                        map: map
                    });
                    allMarkers.push(marker);
                    marker.setMap(map);

                    // Emit the click event so that the global scripts know the latitude and longitude
                    EventBus.$emit('registerLatLng', marker.getPosition().lat(), marker.getPosition().lng());
                });
            }
        },
        mounted() {
            let vm = this;
            EventBus.$on('maps-loaded', () => {
                vm.initMap();
            });
        }
    }
</script>

<style scoped>
    #map {
        width: 100%;
        height: 500px;
    }
</style>
